import { render, staticRenderFns } from "./ProvidusRename.vue?vue&type=template&id=d5b33be8&scoped=true&"
import script from "./ProvidusRename.vue?vue&type=script&lang=js&"
export * from "./ProvidusRename.vue?vue&type=script&lang=js&"
import style0 from "./ProvidusRename.vue?vue&type=style&index=0&id=d5b33be8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b33be8",
  null
  
)

export default component.exports